module.exports = __webpack_public_path__ + "img/main-static.435ca3c0.png";